import Vue from "vue";
import Vuex from "vuex";
import VuexPersistance from "vuex-persist"

import dashboard from "@/store/modules/dashboard/dashboard";

Vue.use(Vuex);

const vuexPersistance = new VuexPersistance({
  key: 'oa-dashboard-vuex',
  storage: window.localStorage,
  modules: ['dashboard'],
  reducer: (state) => ({
    "dashboard": {
      config: state.dashboard.config, menuVisible: state.dashboard.menuVisible,
      dashMaximized: state.dashboard.dashMaximized
    }
  })
})

const store = new Vuex.Store({
  modules: {
    dashboard
  },
  plugins: [
    vuexPersistance.plugin
  ]
});

export default store;